/** 由 scripts/generate-version.js 自動生成，請勿手動編輯 */
export const APP_VERSION = '0.1.20';
